<template minapp='mpx' xlang='wxml'>
  <es-popup 
    closeable="{{false}}"
    show="{{show}}" 
  >
    <view class="contact-dialog" wx:if="{{show}}">
      <slot name="icon"></slot>
      <view>
        <view class="contact-dialog-title">{{title}}</view>
        <view class="contact-dialog-subtitle">{{subTitle}}</view>
        <view class="contact-dialog-slot">
          <slot></slot>
        </view>
        <view class="contact-dialog-content" wx:if="{{content}}">{{content}}</view>
      </view>
      <view class="contact-dialog-btns {{cancelText && confirmText ? 'two-btn' : 'one-btn'}}">
        <view class="contact-dialog-cancel" wx:if="{{cancelText}}" bindtap="cancelTap">{{cancelText}}</view>
        <view class="contact-dialog-confirm" wx:if="{{confirmText}}" bindtap="confirmTap">{{confirmText}}</view>
      </view>
    </view>
  </es-popup>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  createComponent({
    componentName: 'ContactDialog',
    props: {
      show: {
        type: Boolean,
        value: false
      },
      confirmText: {
        type: String,
        value: ''
      },
      cancelText: {
        type: String,
        value: ''
      },
      title: {
        type: String,
        value: ''
      },
      subTitle: {
        type: String,
        value: ''
      },
      content: {
        type: String,
        value: ''
      },
      btnStyle: {
        type: String,
        value: 'slim', // slim, fill
      }
    },
    methods: {
      cancelTap() {
        this.$trigger('cancel')
      },
      confirmTap() {
        this.$trigger('confirm')
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .contact-dialog
    display flex
    flex-direction column
    justify-content space-between
    padding-top 24px
    box-sizing border-box
    width 280px
    min-height 190px
    border-radius 12px
    background linear-gradient(175deg, #D9EBFF 3%, #FFFFFF 26%), #FFFFFF
    &-title
      padding 0 24px
      font-size 20px
      font-weight 400
      line-height 24px
      text-align center
      color #000
      font-family PingFangSC-Medium
    &-subtitle 
      padding 0 24px
      font-size 16px
      font-weight 400
      line-height 18px
      text-align center
      color #000
      margin-top 12px
      font-family PingFangSC-Medium
    &-slot
      padding 0 24px
    &-content
      padding 0 24px
      margin 24px auto
      line-height 22px
      color #212121
      font-size 16px
      font-family PingFangSC-Regular
    &-btns
      display flex
      justify-content space-between
      &.one-btn
        height 50px
        line-height 50px
        color #1473FF
        border-top 1px solid #F3F4F5
        &.one-btn .contact-dialog-cancel,&.one-btn .contact-dialog-confirm
          padding 0
          border 0
      &.two-btn
        margin 0 24px 24px 24px
        color #1473FF
    &-confirm
      margin-left 12px
    &-cancel,&-confirm
      flex 1
      text-align center
      padding 11px
      border-radius 8px
      border 1px solid #1473FF
  
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
    }
  }
</script>

